<template>
  <div class="">
    <div class="base-info">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>基本信息</span>
        </div>
        <el-row>
          <el-col :span="2"><span><el-image :fit="'contain'" :src="player.smallProfile" :preview-src-list="[player.profile]" class="profile"/></span></el-col>
          <el-col :span="19">
            <div class="text item">
              <el-row>
                <el-col :span="12"><span>姓名: {{player.trueName}}</span></el-col>
                <el-col :span="12"><span>证件类型: {{formatCertType(player.certificateType)}}</span></el-col>
                <el-col :span="12"><span>身高: {{player.high}}</span></el-col>
                <el-col :span="12"><span>体重: {{player.weight}}</span></el-col>
                <el-col :span="12"><span>惯用手: {{player.stickHand}}</span></el-col>
              </el-row>
            </div>
            <div class="text item">
              <el-row>
                <el-col :span="12"><span>性别: {{player.gender}}</span></el-col>
                <el-col :span="12"><span>类型: {{player.category}}</span></el-col>
                <el-col :span="12"><span>国籍: {{player.nationality}}</span></el-col>
                <el-col :span="12"><span>俱乐部: {{player.organizationName}}</span></el-col>
              </el-row>
            </div>
            <div class="text item">
              <el-row>
                <el-col :span="12"><span>生日: {{formatDate2(player.birthday)}}</span></el-col>
              </el-row>
            </div>
            <div class="text item">
              <el-row>
                <el-col :span="12"><span>电话: {{player.mobile}}</span></el-col>
              </el-row>
            </div>
            <div class="text item">
              <el-row>
                <el-col :span="12"><span>邮箱: {{player.email}}</span></el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
        <div class="text item">
          <el-row>
            <el-col></el-col>
            <el-col :span="2"><span>证件正面: <el-image :fit="'contain'" :src="player.smallImage" :preview-src-list="[player.bigImage]" class="cert"/></span></el-col>
            <el-col :span="2"><span>证件反面: <el-image :fit="'contain'" :src="player.smallBackImage" :preview-src-list="[player.bigBackImage]" class="cert"/></span></el-col>
          </el-row>
        </div>
      </el-card>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      style="width: 100%">
      <el-table-column
        prop="year"
        label="年度">
      </el-table-column>
      <el-table-column
        prop="gameCount"
        label="场数"
      >
      </el-table-column>
      <el-table-column
        prop="homeWin"
        label="主队胜场"
      >
      </el-table-column>
      <el-table-column
        prop="awayWin"
        label="客队胜场"
      >
      </el-table-column>
      <el-table-column
        prop="goalCount"
        label="进球"
      >
      </el-table-column>
      <el-table-column
        prop="assistCount"
        label="助攻"
      >
      </el-table-column>
      <el-table-column
        prop="shootoutCount"
        label="点球进球"
      >
      </el-table-column>
      <el-table-column
        prop="shootoutWinCount"
        label="点球制胜球"
      >
      </el-table-column>
      <el-table-column
        prop="plusCount"
        label="加时(min)"
      >
      </el-table-column>
      <el-table-column
        prop="plusGoalCount"
        label="加时进球"
      >
      </el-table-column>
      <el-table-column
        prop="penaltyCount"
        label="罚时(min)"
      >
      </el-table-column>
      <el-table-column
        prop="anyShootCount"
        label="射门"
      >
      </el-table-column>
      <el-table-column
        prop="eqCount"
        label="EQ"
        sortable="custom"
      >
      </el-table-column>
      <el-table-column
        prop="enCount"
        label="EN"
        sortable="custom"
      >
      </el-table-column>
      <el-table-column
        prop="p1Count"
        label="+1"
        sortable="custom"
      >
      </el-table-column>
      <el-table-column
        prop="p2Count"
        label="+2"
        sortable="custom"
      >
      </el-table-column>
      <el-table-column
        prop="m1Count"
        label="-1"
        sortable="custom"
      >
      </el-table-column>
      <el-table-column
        prop="m2Count"
        label="-2"
        sortable="custom"
      >
      </el-table-column>
      <el-table-column
        prop="psCount"
        label="PS"
        sortable="custom"
      >
      </el-table-column>
      <el-table-column
        prop="gwgCount"
        label="GWG"
        sortable="custom"
      >
      </el-table-column>
      <el-table-column
        prop="keepLoseCount"
        label="守丢数"
        sortable="custom"
      >
      </el-table-column>
      <el-table-column
        prop="keepCount"
        label="守住数"
        sortable="custom"
      >
      </el-table-column>
      <el-table-column
        prop="keepLoseWinCount"
        label="守丢至输"
        sortable="custom"
      >
      </el-table-column>
    </el-table>
    <div class="table-footer">
      <el-pagination
        v-show="totalCount>0"
        @size-change="handleSizeChange"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="totalCount"
        background
        layout="total, sizes, prev, pager, next"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>

import * as moment from 'moment'
import { ImageFormat } from '@/utils'
import { GetPlayerYearsList } from '@/api/player'

export default {
  name: 'PlayerYearList',
  data() {
    return {
      list: [],
      totalCount: 0, // 默认数据总数
      pageSize: 10, // 每页的数据条数
      currentPage: 1, // 默认开始页面
      listQuery: {},
      listLoading: true,
      playerId:null,
      player:{
        smallProfile:'http://image.bjh.snsports.cn/Fn8CbV2swfbWFyuYHsQyfEtp4JwB',
        profile:'http://image.bjh.snsports.cn/Fn8CbV2swfbWFyuYHsQyfEtp4JwB',
        smallImage:'http://image.bjh.snsports.cn/Fn8CbV2swfbWFyuYHsQyfEtp4JwB',
        bigImage:'http://image.bjh.snsports.cn/Fn8CbV2swfbWFyuYHsQyfEtp4JwB',
        smallBackImage:'http://image.bjh.snsports.cn/Fn8CbV2swfbWFyuYHsQyfEtp4JwB',
        bigBackImage:'http://image.bjh.snsports.cn/Fn8CbV2swfbWFyuYHsQyfEtp4JwB'
      }
    }
  },
  created() {
    this.playerId = this.$route.query.playerId
    this.getList()
  },
  mounted() {},
  methods: {
    getList(){
      this.listLoading = true
      this.listQuery = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        playerId: this.playerId,
      }
      this.listQuery = Object.assign(this.listQuery, this.search)
      GetPlayerYearsList(this.listQuery).then(resolve=>{
        const data = resolve.data
        this.list = data.years
        this.currentPage = data.pageNum
        this.totalCount = data.count
        this.listLoading = false
        let player = data.player
        player.smallProfile = this.ImageFormats(player.profile, 150)
        player.profile = this.ImageFormats(player.profile, 1000)
        player.smallImage = this.certImageFormats(player.certificateFrontImg, 150, 94)
        player.bigImage = this.certImageFormats(player.certificateFrontImg, 1000, 1000)
        player.smallBackImage = this.certImageFormats(player.certificateBackImg, 150, 94)
        player.bigBackImage = this.certImageFormats(player.certificateBackImg, 1000, 1000)
        this.player = player
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.$router.push({path: this.$route.path, query: {page: val}})
      this.currentPage = val
      this.getList()
    },
    quickSearch() {
      this.getList()
    },
    ImageFormats(img) {
      return ImageFormat.squareImageView(img, 100, 2)
    },
    certImageFormats(img, w, h) {
      img = img || 'Fn8CbV2swfbWFyuYHsQyfEtp4JwB'
      return ImageFormat.imageView(img, w, h)
    },
    formatCertType(type) {
      const t = parseInt(type)
      return t === 1 ? "身份证" : (t === 2 ? "护照" : (t === 3 ? "出生证" : (t === 4 ? "驾照" : "-")))
    },
    formatDate2: function(date) {
      return date && moment(date).format('YYYY-MM-DD')
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss">

  .table-footer {
    text-align: center;
    margin-top: 30px;
  }
</style>
